export default __webpack_public_path__ + "static/media/Mapa_manuable.2bc98e58.png";